import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownInitiatorsChange } from '../../api';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';
import { InitiatorsField, MainInitiatorField } from '../../../createNew/common';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownInitiatorsChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const mainInit = formValues[fieldNames.mainInitiator];

        const entitiesFromForm = (formValues[fieldNames.initiators] || []).map(
          (id) => ({
            id,
            isMain: id === mainInit ? 1 : 0,
          })
        );

        await change({
          shutdownId: shutdown.alertId,
          data: [...entitiesFromForm],
        });
        close();
      }
    });
  };

  const initialValueInit = shutdown?.initiators?.map((item) => item.id) || [];
  const initialValueMainInit =
    shutdown?.initiators?.find((item) => !!item.isMain)?.id || null;

  return (
    <Modal
      visible={type === modalTypes.addShutdownInitiators}
      onCancel={close}
      onOk={handleSubmit}
      title="Изменить инициаторов"
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.cityServices}
      />
      <Form colon={false}>
        <InitiatorsField
          form={form}
          editMode
          shutdown={shutdown}
          initialValueInit={initialValueInit}
        />
        <MainInitiatorField
          form={form}
          editMode
          shutdown={shutdown}
          initialValueMainInit={initialValueMainInit}
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_initiators' })(
  ModalContainer
);

export default ChangeModal;
